import {
  getCouponSelectModalCouponPlatformList,
  MaxCouponDiscountCouponPlatformRequiredParams,
} from '~/api/converters/domestic/order/Discount/CouponSelectModal/couponPlatform'
import {
  CouponPlatformCouponTarget,
  ICouponInstances,
  TCouponPlatformCouponTarget,
} from '~/api/services/coupon-platform/index.type'
import getMaxCouponDiscount from '~/api/converters/domestic/order/Coupons/MaxDiscountCoupons/getMaxCouponDiscount'
import { IDomesticOrderDiscountCouponSelectModalCoupon } from '~/api/converters/domestic/order/Discount/CouponSelectModal/index.type'
import { TMaxDiscountLimit } from '~/api/routes/domestic/order/controller/type'

export const getCouponPlatformId = (c: ICouponInstances) => {
  return `${c.id ?? ''}:${c.couponId}:${c.redemptionPolicy?.stock?.id ?? ''}`
}

// 국내 숙소 이외의 카테고리 상품쿠폰 여부 조회
export const getIsCouponPlatformProductCoupon = (
  couponTarget: TCouponPlatformCouponTarget
): boolean => {
  return couponTarget === CouponPlatformCouponTarget.PRODUCT
}

export const mapCouponPlatformDiscountAppliedItem = (
  coupon: ICouponInstances,
  typeIdx: number,
  item: MaxCouponDiscountCouponPlatformRequiredParams
): IDomesticOrderDiscountCouponSelectModalCoupon => {
  return getCouponSelectModalCouponPlatformList({ coupons: [coupon], typeIdx, item })[0]
}

/**
 *  @description  국내 숙소 이외의 카테고리 최대 할인 금액을 계산하기 위한 쿠폰 정보 변환
 */
const mapCouponPlatform = (coupon: ICouponInstances | null, itemLength: number) => {
  if (!coupon) {
    return {
      id: '',
      price: 0,
      remainCount: 0,
    }
  }

  let remainCount = 1

  if (getIsCouponPlatformProductCoupon(coupon.couponTarget)) {
    // 남은 재고 숫자
    const remainStockCount = coupon.redemptionPolicy.stock?.remain ?? itemLength
    // 최대 적용 가능 갯수
    const maxUseCount = coupon.redemptionPolicy.maxUseCount?.remain ?? itemLength
    remainCount = remainStockCount > maxUseCount ? maxUseCount : remainStockCount
  }

  return {
    id: getCouponPlatformId(coupon),
    price: coupon.confirmedDiscount,
    remainCount,
  }
}

/**
 *  @summary   coupon-platform(레저, 기차, 버스) 최대 할인 계산.
 *  @description 알고리즘은 국내숙소와 동일 (backtracking) - getDomesticCouponMaxDiscount
 * */
export const getCouponPlatformMaxDiscount = (
  items: MaxCouponDiscountCouponPlatformRequiredParams[],
  maxDiscountLimit: TMaxDiscountLimit
) => {
  const sortedItems = [...items].sort((a, b) => (b?.price ?? 0) - (a?.price ?? 0))

  const filterCoupon = (coupon: ICouponInstances | null) => {
    if (coupon === null) return true
    let remainCount = 1
    if (getIsCouponPlatformProductCoupon(coupon.couponTarget)) {
      // 남은 재고 숫자
      const remainStockCount = coupon.redemptionPolicy.stock?.remain ?? items.length
      // 최대 적용 가능 갯수
      const maxUseCount = coupon.redemptionPolicy.maxUseCount?.remain ?? items.length
      remainCount = remainStockCount > maxUseCount ? maxUseCount : remainStockCount
    }
    return coupon.violations.length === 0 && remainCount > 0
  }

  return getMaxCouponDiscount<ICouponInstances & { allowAdditional?: boolean }>({
    maxDiscountLimit,
    items: sortedItems.map(item => ({
      ...item,
      additionalOneCoupons: [],
      additionalTwoCoupons: [],
    })),
    filterCoupon,
    mapCoupon: coupon => mapCouponPlatform(coupon, items.length),
    mapCouponDiscountAppliedItem: (coupon, typeIdx) =>
      mapCouponPlatformDiscountAppliedItem(coupon, typeIdx, items[typeIdx]),
  })
}
